const styles = `
    <style>
        .ms--submit {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 44px;
            min-width: 64px;
            border-radius: 8px;
            background: #0D0D0D;
            color: #FFF;
            font-size: 16px;
            font-weight: 500;
            line-height: 140%;
            border: none;
            padding: 5px 30px;
            cursor: pointer;
            text-decoration: none;
            max-width: 200px;
            margin: 0 auto; 
        }

        .ms--submit:hover {
            background-color: #212121;
            text-decoration: none;
            color: #FFF;
        }

        .ms--submit-container {
            margin-top: 15px;
        }
    </style>
`;

const getButtonContent = text => `
    <div class="ms--submit-container">
        <a href="#" class="ms--submit">${text}</a>
    </div>
`;

// eslint-disable-next-line import/prefer-default-export
export const getMicrosoftCtaPreview = (html, ctaText) => {
  const result = html.includes('%microsoft_form_button%')
    ? html.replace('%microsoft_form_button%', getButtonContent(ctaText))
    : html.replace('</body>', `${getButtonContent(ctaText)}</body>`);
  return result.replace('</head>', `${styles}</head>`);
};
